document.addEventListener("DOMContentLoaded", function () {

  // Thumbnails FIRST
const thumbs = new Swiper(".product-thumb-slider", {
  slidesPerView: "auto",
  spaceBetween: 10,
  freeMode: true,
  watchSlidesProgress: true,
});

  // Main slider
  const main = new Swiper(".product-main-slider", {
    slidesPerView: 1,
    spaceBetween: 10,

    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },

    thumbs: {
      swiper: thumbs,
    }
  });

  // Variant data
  const variants = JSON.parse(
    document.getElementById("ProductVariants").textContent
  );

  const mainImg = document.getElementById("variant-featured-image");
  const thumbImg = document.getElementById("variant-thumb-image");

  function updateVariant(variantId) {

    const variant = variants.find(v => v.id == variantId);
    if (!variant) return;

    const img =
      variant.featured_image?.src ||
      variant.featured_media?.preview_image?.src;

    if (!img) return;

    if (mainImg.dataset.current === img) return;

    mainImg.dataset.current = img;

    mainImg.src = img + "&width=1400";

    if (thumbImg) {
      thumbImg.src = img + "&width=150";
    }

    main.slideTo(0, 0);
  }

  function getVariantId() {
    const input = document.querySelector('[name="id"]');
    return input ? input.value : null;
  }

  document.addEventListener("change", function () {
    const id = getVariantId();
    if (!id) return;
    updateVariant(id);
  });

});